<template>
    <div class="show-more" v-if="remains > 0">
        <a href="javascript:void(0)" class="py-2 default-bold text-primary" v-if="remains>0 && !showAll" @click="show()">vedi altre {{remains}} alternative</a>
        <a href="javascript:void(0)" class="py-2 default-bold text-primary" v-if="showAll" @click="hide()">vedi solo i risultati principali</a>
    </div>
</template>

<script>
export default {
  name: 'ShowMore',
  props: {
    showAll: {
      type: Boolean,
      default: false
    },
    remains: {
      type: Number,
      default: 0
    },
    scrollTo: {
      type: String,
      default: 'app'
    }
  },
  methods: {
    show () {
      this.$emit('click', {open: true})
    },
    hide () {
      this.$scrollTo('#' + this.scrollTo)
      this.$emit('click', {open: false})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/ShowMore.vue